export default ({
  bold,
  italic,
  underline,
  unorderedList,
  comment,
  setMarkType,
}) => {
  const marks = {};
  let shouldDispatch = false;
  if (bold) {
    marks.bold = false;
    if (!shouldDispatch) shouldDispatch = true;
  }

  if (italic) {
    marks.italic = false;
    if (!shouldDispatch) shouldDispatch = true;
  }

  if (underline) {
    marks.underline = false;
    if (!shouldDispatch) shouldDispatch = true;
  }

  if (unorderedList) {
    marks.unorderedList = false;
    if (!shouldDispatch) shouldDispatch = true;
  }

  if (comment) {
    marks.comment = false;
    if (!shouldDispatch) shouldDispatch = true;
  }

  if (shouldDispatch) {
    setMarkType(marks);
  }
};
